import { Component, OnInit, EventEmitter, Output, Input, ɵConsole } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CategorySearchService } from '../_services/category-search.service';
import { CategorySearchDetails } from '../_models/category-search-details';
import { FormBuilder, FormGroup, FormControl, FormArray } from '@angular/forms';
import * as _ from "lodash";
import { CookieService } from '../../../node_modules/ngx-cookie-service';


@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit {

  categoryId: Number;
  updateFlag = '';
  categorySearchDetails: CategorySearchDetails;
  filtersList: any[] = [];
  productCategoryName: Array<String> = [];
  imageURL: String;
  parentCategoryName: any;
  productCount: any;
  isSelected: Boolean = true;
  finalProduct = [];
  interestFormGroup: FormGroup;
  products = [];
  attributeValue = [];
  attributeName = [];
  productIdList = []
  filterList = []
  productAttribute = [];
  attributeValues = [];
  categoryAttributeValues = [];
  value = [];
  userId: Number;
  keyValue = '';
  selected = 'Latest'
  searchKeyword = '';
  userRole: Number;
  searchText: any;
  afterFilter = [];
  searchProduct: string;

  // checkedValue: boolean=true;
  constructor(
    private activatedRoute: ActivatedRoute,
    private categoryService: CategorySearchService,
    private formBuilder: FormBuilder,
    private router: Router,
    private cookie: CookieService
  ) {

    this.activatedRoute.params.subscribe(params => {
      this.categoryId = params['id'];
      this.productCategoryName = params['categoryName']
      this.updateFlag = 'true';

    });
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;


  }


  ngOnInit() {
    this.afterFilter = this.finalProduct;
    this.getCategoryDetailsById(this.categoryId)
    this.search()

  }


  /*---to get userid from cookies*/
  getCategoryDetailsById(categoryId: Number) {
    this.userId = +(this.cookie.check("UserId") ? this.cookie.get("UserId") : null);
    console.log("my", this.userRole);
    this.categoryService.getCategoryDetailsById(categoryId, this.userId, this.keyValue, this.searchKeyword).subscribe(resp => {
      this.categorySearchDetails = resp as CategorySearchDetails;
      console.log(JSON.stringify(this.categorySearchDetails))
      this.imageURL =this.categorySearchDetails.productCategory['imageURL']
      console.log("category imageURL", this.imageURL)
      this.parentCategoryName = this.categorySearchDetails.productCategory['parentCategoryName']
      this.productCount = this.categorySearchDetails.productCategory['totalProducts']
      this.filtersList = this.categorySearchDetails.categoryFilters;
      this.products = this.categorySearchDetails.products
      console.log(this.products)
      if (this.filtersList != null) {
        this.filtersList.filter(filters => {
          this.categoryAttributeValues = filters.categoryAttributeValues
          if (this.categoryAttributeValues != null) {
            this.categoryAttributeValues.forEach(resp => {
              resp['isIncluded'] = true

            })
          }
          this.filterList.push({
            categoryAttributeName: filters.categoryAttributeName, categoryAttributeValues: this.categoryAttributeValues, categoryAttributeId: filters.categoryAttributeId
          })
        })
      }
      var UserRole = this.cookie.get('UserRole')
      if (UserRole != "User") {
        if (this.products != null) {
          this.products.filter(products => {
            let i = this.finalProduct.findIndex(x => x.value == products.productId);
            if (i <= -1) {
              console.log(products.mainImage, "my product image is here")
              products.mainImage=products.mainImage
              this.finalProduct.push({
                productId: products.productId, mainImage: products.mainImage, hoverImage: products.hoverImage, availableColors: products.availableColors,
                price: products.price, productName: products.productName, isSelected: true, availableSize: products.availableSize, productCategoryAttribute: products.productCategoryAttribute
              })
            }
          })
        }
      }
      else {
        if (this.products != null) {
          this.products.filter(products => {
            let i = this.finalProduct.findIndex(x => x.value == products.productId);
            if (i <= -1) {
              console.log(products.mainImage, "my product image is here")
              this.finalProduct.push({
                productId: products.productId, mainImage: products.mainImage, hoverImage: products.hoverImage, availableColors: products.availableColors,
                price: products.price, productName: products.productName, isSelected: true, availableSize: products.availableSize, productCategoryAttribute: products.productCategoryAttribute
              })
            }
          })
        }
      }
    })

    console.log("final product array........", this.finalProduct)
  }


  filter(event, value) {
    console.log("on clicking event..........", event)
    // if(event.checked == false){
    //   this.checkedValue=false
    // }
    console.log("on clicking value..........", value)
    console.log(this.filterList)
    console.log(this.finalProduct)

    if (!event.checked) {
      this.finalProduct.filter(filterProducts => {
        if (filterProducts.productCategoryAttribute != null) {
          filterProducts.productCategoryAttribute.filter((categoryAttribute, i) => {
            this.filterList.filter(finalFilters => {
              if (finalFilters.categoryAttributeValues != null) {
                finalFilters.categoryAttributeValues.filter(filter => {
                  if (value.isIncluded == true && value.attributeValue == filter.attributeValue) {
                    filter.isIncluded = false
                  }
                  if (filter.isIncluded == false && value.attributeValue == categoryAttribute.categoryAttributeValue) {
                    filterProducts.isSelected = false
                  }
                })
              }
            })
          })
        }
      })
    }
    else {
      this.finalProduct.filter(filterProducts => {
        if (filterProducts.productCategoryAttribute != null) {
          filterProducts.productCategoryAttribute.filter((categoryAttribute, i) => {
            this.filterList.filter(finalFilters => {
              if (finalFilters.categoryAttributeValues != null) {
                finalFilters.categoryAttributeValues.filter(filter => {
                  if (value.isIncluded == false && value.attributeValue == filter.attributeValue) {
                    filter.isIncluded = true
                  }
                  if (filter.isIncluded == true && value.attributeValue == categoryAttribute.categoryAttributeValue) {
                    filterProducts.isSelected = true
                  }
                })
              }
            })
          })
        }

      })

    }

  }

  CheckAllOptions(event, value) {
    console.log(event)
    console.log(value)
    console.log(this.filterList)
    console.log(this.finalProduct)

    if (!event.checked) {
      this.finalProduct.filter(filterProducts => {
        if (filterProducts.productCategoryAttribute != null) {
          filterProducts.productCategoryAttribute.filter((categoryAttribute, i) => {
            this.filterList.filter(finalFilters => {
              if (finalFilters.categoryAttributeValues != null) {
                finalFilters.categoryAttributeValues.filter(filter => {
                  for (let i in value) {
                    if (value[i].isIncluded == true && value[i].attributeValue == filter.attributeValue) {
                      filter.isIncluded = false
                    }
                    if (filter.isIncluded == false && value[i].attributeValue == categoryAttribute.categoryAttributeValue) {
                      filterProducts.isSelected = false
                    }
                  }
                })
              }
            })
          })
        }

      })
    }
    else {
      this.finalProduct.filter(filterProducts => {
        if (filterProducts.productCategoryAttribute != null) {
          filterProducts.productCategoryAttribute.filter((categoryAttribute, i) => {
            this.filterList.filter(finalFilters => {
              if (finalFilters.categoryAttributeValues != null) {
                finalFilters.categoryAttributeValues.filter(filter => {
                  for (let i in value) {
                    if (value[i].isIncluded == false && value[i].attributeValue == filter.attributeValue) {
                      filter.isIncluded = true
                    }
                    if (filter.isIncluded == true && value[i].attributeValue == categoryAttribute.categoryAttributeValue) {
                      filterProducts.isSelected = true
                    }
                  }
                })
              }
            })
          })
        }

      })

    }

  }

  getSortedProducts(event) {
    this.finalProduct = []
    this.filterList = []
    this.categoryService.getCategoryDetailsById(this.categoryId, this.userId, event, this.searchKeyword).subscribe(resp => {
      this.categorySearchDetails = resp as CategorySearchDetails;
      console.log(this.categorySearchDetails)
      this.imageURL = this.categorySearchDetails.productCategory['imageURL']
      this.parentCategoryName = this.categorySearchDetails.productCategory['parentCategoryName']
      this.productCount = this.categorySearchDetails.productCategory['totalProducts']
      this.filtersList = this.categorySearchDetails.categoryFilters;
      this.products = this.categorySearchDetails.products
      this.filtersList.filter(filters => {
        this.categoryAttributeValues = filters.categoryAttributeValues
        if (this.categoryAttributeValues != null) {
          this.categoryAttributeValues.forEach(resp => {
            resp['isIncluded'] = true

          })
        }
        this.filterList.push({
          categoryAttributeName: filters.categoryAttributeName, categoryAttributeValues: this.categoryAttributeValues, categoryAttributeId: filters.categoryAttributeId
        })
      })

      this.products.filter(products => {
        let i = this.finalProduct.findIndex(x => x.value == products.productId);
        if (i <= -1) {
          this.finalProduct.push({
            productId: products.productId, mainImage: products.mainImage, hoverImage: products.hoverImage, availableColors: products.availableColors,
            price: products.price, productName: products.productName, isSelected: true, availableSize: products.availableSize, productCategoryAttribute: products.productCategoryAttribute
          })
        }
      })
    })


  }
  /*---Sorting Dropdown List--- */
  sortingList: Sort[] = [
    { value: '0', viewValue: 'Latest' },
    { value: '1', viewValue: 'Price (Low to High)' },
    { value: '2', viewValue: 'Price (High to Low)' },
  ];

  searchKey(data: string) {
    this.searchText = data;
    this.search();
  }

  search() {
    if (this.finalProduct.length != null && this.finalProduct.length != 0) {
      console.log("this.finalProduc"+this.finalProduct)
      for(let data of this.finalProduct){
        console.log("this.finalProduc"+data)
      }
      this.afterFilter = this.finalProduct.filter((data) => {
        console.log(this.searchText.toLowerCase())
        console.log(data.productName.toLowerCase().includes(this.searchText.toLowerCase()))
        return data.productName.toLowerCase().includes(this.searchText.toLowerCase())
      })
    }
  }
}

/*---Interface for sorter values----*/
export interface Sort {
  value: string;
  viewValue: string;
}
